import { Injectable, Injector } from '@angular/core';

import { Utilities_FrontendFlowService } from './Utilities.frontend.flow.index';
import { Addresses_FrontendFlowService } from './Addresses.frontend.flow.index';
import { Carriers_FrontendFlowService } from './Carriers.frontend.flow.index';
import { PurchaseOrders_FrontendFlowService } from './PurchaseOrders.frontend.flow.index';
import { SalesOrders_FrontendFlowService } from './SalesOrders.frontend.flow.index';
import { Notifications_FrontendFlowService } from './Notifications.frontend.flow.index';
import { Materials_FrontendFlowService } from './Materials.frontend.flow.index';
import { Invoices_FrontendFlowService } from './Invoices.frontend.flow.index';
import { Inventory_FrontendFlowService } from './Inventory.frontend.flow.index';
import { FootprintApiManager_FrontendFlowService } from './FootprintApiManager.frontend.flow.index';
import { Reports_FrontendFlowService } from './Reports.frontend.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FrontendFlowService {

  constructor(
    public Utilities: Utilities_FrontendFlowService,
    public Addresses: Addresses_FrontendFlowService,
    public Carriers: Carriers_FrontendFlowService,
    public PurchaseOrders: PurchaseOrders_FrontendFlowService,
    public SalesOrders: SalesOrders_FrontendFlowService,
    public Notifications: Notifications_FrontendFlowService,
    public Materials: Materials_FrontendFlowService,
    public Invoices: Invoices_FrontendFlowService,
    public Inventory: Inventory_FrontendFlowService,
    public FootprintApiManager: FootprintApiManager_FrontendFlowService,
    public Reports: Reports_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public app: app_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
